import React, { useState } from 'react'
import styles from './index.scss';
import { Modal, withPortal } from 'jd-library';
import Button from "../../../common/Button/Button";

const CorrectnessModel = ({ data, setCorrectnessModel, productOrService, categoryName }) => {

    const [isScrolled, setScrolled] = useState(false)
    const prodOrServ = productOrService.charAt(0).toUpperCase() + productOrService.slice(1);
    const { specs = "", specsError = "", primaryImageError = "", primaryImageReason = "", descriptionProductNameError = "", descriptionSpecError = "", priceError = "" } = data.data
    const entries = Object.entries(specs);

    const scrollHandler = (e) => {
        setScrolled(e.target.scrollTop > 5);
    }

    return (
        <Modal
            settings={{
                modalId: "CorrectnessProduct",
                variant: "action",
                class: styles["correctness-model"],
            }}
            backdropStatic={true}
            onHidden={() => setCorrectnessModel({ ...data, show: false })}>
            <Modal.CloseIcon iconClass={'icon-HDRcross'} />
            <div className={`${styles["title"]} ${isScrolled ? styles["scrollClass"] : ""}`}>{prodOrServ} Information Not Matching</div>
            <div className={styles["content"]} onScroll={scrollHandler} body-scroll-lock-ignore='true'>
                {primaryImageError == 1 ? <p>The primary image does not match with the {productOrService} name. <b>{primaryImageReason}.</b> Please upload a valid {productOrService} image to proceed ahead.</p> : null}
                {specsError == 1 ?
                    <>
                        <p className={styles["ignore-bottom"]}>The following specifications don't match with the {productOrService} name</p>
                        <p className={styles["ignore-bottom"]}><b>{entries.map(([key, value], ind) => <p className={styles["ignore-bottom"]}>{key} : {value.specification_value}{ind == entries.length - 1 ? "." : ""}</p>)}</b></p>
                        <p>Please enter valid specifications to proceed ahead.</p>
                    </>
                    : null}
                {descriptionProductNameError == 1 ? <p>The {productOrService} description does not match with the {productOrService} name. Please enter valid {productOrService} description to proceed ahead.</p> : null}
                {descriptionSpecError == 1 ? <p>The {productOrService} description does not match with the entered specifications. Please enter valid description to proceed ahead.</p> : null}
                {priceError == 1 ? <p>The {productOrService} price is not appropriate for <b>{categoryName}.</b> Please enter valid price to proceed ahead.</p> : null}
            </div>
            <div className={styles["footer"]}>
                <Button
                    size="lg"
                    block
                    variant={"primary"}
                    className={styles["btn"]}
                    clickHandler={() => window.history.back()}>
                    Okay, Got It
                </Button>
            </div>
        </Modal>
    )
}

export default withPortal(CorrectnessModel)